import React from "react"
import { IconButton, Panel } from "@walmart-web/livingdesign-components"
import "./index.scss"
import { Icon } from "@walmart-web/livingdesign-icons"

interface PanelProps {
	isOpen: boolean
	onClose: () => void
	title: string
	content: React.ReactNode
}

const InformationPanel: React.FC<PanelProps> = ({
	isOpen,
	onClose,
	title,
	content,
}) => (
	<Panel
		isOpen={isOpen}
		onClose={() => onClose()}
		position="left"
		size="medium"
		UNSAFE_className="information-panel"
		title={title}
	>
		<div className="information-content">{content}</div>
	</Panel>
)

interface InfoButtonProps {
	setIsOpen(value: boolean): void
	isOpen: boolean
}

export const InfoButton: React.FC<InfoButtonProps> = ({
	setIsOpen,
	isOpen,
}) => {
	return (
		<IconButton
			size="medium"
			a11yLabel="information"
			UNSAFE_className="header-icon"
			onClick={() => setIsOpen(!isOpen)}
		>
			<Icon name="InfoCircle" />
		</IconButton>
	)
}

export default InformationPanel
